<template>
    <div class="user-reset-password mb-3 mt-page">

        <b-row class="justify-content-md-center">
            <b-col cols="12" md="6" md-offset="3">
                <h1>{{ $i18n.gt('LABEL_RESET_PASSWORD') }}</h1>

                <div v-if="state == SUBMITTING">
                    <b-alert show variant="info">
                        <p v-html="$i18n.gt('MESSAGE_PASSWORD_INSTRUCTIONS')"></p>
                        <p v-html="$i18n.gt('MESSAGE_PASSWORD_REQUIREMENTS')"></p>
                    </b-alert>
                    <data-form :save-button-label="$i18n.gt('LABEL_SAVE')"
                               :field-model="userFields"
                               :field-groups="fieldGroups"
                               :on-submit-handler="onSubmit">
                    </data-form>
                </div>

                <!-- TODO: show something while waiting for form to process -->

                <div v-if="state == SUBMITTED">
                    <b-alert show variant="success">
                        {{ $i18n.gt('MESSAGE_PASSWORD_RESET_REQUEST') }}
                    </b-alert>
                </div>

                <div v-if="state == SUBMIT_ERROR">
                    <b-alert show variant="danger">
                        {{ $i18n.gt('MESSAGE_ERROR_SUBMITTING_PASSWORD_RESET') }}
                        <br>
                        <b-btn variant="primary" size="sm" class="float-right mt-3"
                        @click="resetForm()">
                            {{ $i18n.gt('LABEL_PASSWORD_RESET_TRY_AGAIN') }}
                        </b-btn>
                        <div class="clearfix"></div>
                    </b-alert>
                </div>

                <div v-if="state == CONFIRMING">
                    <b-alert show variant="info">
                        {{ $i18n.gt('MESSAGE_CONFIRMING_PASSWORD_RESET') }}
                    </b-alert>
                </div>

                <div v-if="state == CONFIRMED">
                    <b-alert show variant="success">
                        <p>
                            {{ $i18n.gt('MESSAGE_PASSWORD_IS_RESET') }}
                        </p>
                        <p>
                            <router-link to="/">
                                {{ $i18n.gt('HEADING_LOGIN') }}
                            </router-link>
                        </p>

                    </b-alert>
                </div>

                <div v-if="state == CONFIRM_ERROR">
                    <b-alert show variant="danger">
                        {{ $i18n.gt('MESSAGE_CANT_CONFIRM_PASSWORD_RESET') }}
                    </b-alert>
                </div>

            </b-col>
        </b-row>
    </div>

</template>

<script>

import Vue from 'vue'
import UserFields from '@/models/User'

/**
 * Page for a User to reset their password
 */
export default Vue.extend({
    name: 'UserResetPassword',
    data() {
        return {
            userFields: UserFields,
            fieldGroups: [
                ['email', 'password', 'password_repeat'],
            ],
            SUBMITTING: 1,
            SUBMITTED: 2,
            SUBMIT_ERROR: 3,
            CONFIRMING: 4,
            CONFIRMED: 5,
            CONFIRM_ERROR: 6,
            state: 1
        }
    },
    computed: {
        email() {
            return this.$route.params.email
        },
        confirm() {
            return this.$route.params.confirm
        }
    },
    methods: {
        resetForm() {
            this.state = this.SUBMITTING
        },
        async onSubmit(modelInstance) {
            try {
                await this.$user.resetPassword(this, modelInstance.email, modelInstance.password)
                this.state = this.SUBMITTED
            } catch (e) {
                this.state = this.SUBMIT_ERROR
                this.$api.log(this, 'user', null, 'reset/confirm',
                    `User password reset confirmation failed: ${modelInstance.email}`)
            }
        }
    },
    async mounted() {
        if (this.confirm) {
            this.state = this.CONFIRMING
            try {
                await this.$user.confirmPasswordReset(this, this.email, this.confirm)
                this.state = this.CONFIRMED
            } catch (e) {
                this.state = this.CONFIRM_ERROR
            }
        }
    }
})

</script>
